import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { GenderKeyType, GENDERS_VALUES } from 'constants/profile';
import { useQuery } from '@apollo/client';
import { GET_APPOINTMENT_ITEM } from 'gql/appointments/queries';
import { AppointmentById } from 'gql/appointments/__generated__/AppointmentById';

import { InfoItem } from './components';
import { StyledInfoContainer } from './styled';
import { getFileUrl } from 'utils/file';

export interface IProps {
  date: string;
}

const AppointmentInfo: FC<IProps> = ({ date }) => {
  const { t } = useTranslation();

  const params = useParams();

  const { data } = useQuery<AppointmentById>(GET_APPOINTMENT_ITEM, {
    skip: !params.id,
    variables: {
      id: params.id
    },
    fetchPolicy: 'cache-only'
  });

  const appointment = data?.appointment?.data;

  if (!appointment) return null;

  return (
    <StyledInfoContainer size={42}>
      <InfoItem
        title={`${
          appointment.patient?.date_of_birth &&
          dayjs().diff(dayjs(appointment.patient.date_of_birth), 'years')
        }, ${
          appointment.patient?.gender &&
          t(
            `appointments_details.${
              GENDERS_VALUES[appointment.patient.gender as GenderKeyType]
            }`
          )
        }`}
        subtitle={`${appointment.patient.first_name} ${appointment.patient.last_name}`}
        uri={getFileUrl(appointment.patient.avatar || '')}
      />
      <InfoItem
        title={t('appointments_details.created_at')}
        subtitle={dayjs(appointment?.created_at).format('DD-MM-YYYY HH:mm')}
        icon="calendar"
      />
      <InfoItem
        title={t('appointments_details.appointment_date')}
        subtitle={date}
        icon="calendar"
      />
      <InfoItem
        title={t('appointments_details.service')}
        subtitle={appointment.plan.name}
        icon="heart"
      />
    </StyledInfoContainer>
  );
};

export default memo(AppointmentInfo);
